import { checkIcon, crossIcon } from "../../../assets/icons";

const ToastMessage = ({ notificationMessage, setShouldShowNotification }) => (
  <div
    id="toast-success"
    className="absolute top-5 right-5 flex w-full max-w-xs items-center rounded-lg bg-white p-4 text-gray-500 shadow dark:bg-gray-800 dark:text-gray-400"
    role="alert"
  >
    <div className="inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-blue-200 text-blue-300 dark:bg-blue-700 dark:text-blue-200">
      <img src={checkIcon} alt="success-icon" />
      <span className="sr-only">Warning icon</span>
    </div>
    <div className="ml-3 text-sm font-normal">{notificationMessage}</div>
    <button
      type="button"
      className="-mx-1.5 -my-1.5 ml-auto inline-flex h-8 w-8 rounded-lg bg-white p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-900 focus:ring-2 focus:ring-gray-300 dark:bg-gray-800 dark:text-gray-500 dark:hover:bg-gray-700 dark:hover:text-white"
      data-dismiss-target="#toast-success"
      aria-label="Close"
      onClick={() => setShouldShowNotification(false)}
    >
      <span className="sr-only">Close</span>
      <img src={crossIcon} alt="cross-icon" />
    </button>
  </div>
);

export default ToastMessage;
